// extracted by mini-css-extract-plugin
export default {"backButton":"_16b4b05835 _01848cfab2 _40921a402b _244601795d"};